import React from 'react';
import { FiRefreshCw } from 'react-icons/fi';

const SORT_OPTIONS = [
  { value: 'default', label: 'Default' },
  { value: 'price_asc', label: 'Price: Low to High' },
  { value: 'price_desc', label: 'Price: High to Low' },
  { value: 'departure_asc', label: 'Departure: Earliest First' },
  { value: 'departure_desc', label: 'Departure: Latest First' },
  { value: 'duration_asc', label: 'Duration: Shortest First' },
  { value: 'duration_desc', label: 'Duration: Longest First' },
  { value: 'airport_asc', label: 'Airport: A to Z' },
  { value: 'airport_desc', label: 'Airport: Z to A' },
];

const FlightFilters = ({ filters, onFilterChange, onReset }) => {
  return (
    <div className="w-64 flex-shrink-0">
      <div className="p-4">
        <h3 className="text-base font-bold text-[#000] mb-4 pb-2 border-b border-[#eee]">Filter By</h3>

        {/* Filter By Section */}
        <div className="mb-4 space-y-2">
          {['lowestPax', 'fastestFlightTime'].map((key) => (
            <label key={key} className="flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={filters[key]}
                onChange={(e) => onFilterChange(key, e.target.checked)}
                className="mr-2 w-4 h-4 accent-[#e87722]"
              />
              <span className="text-sm text-[#333]">
                {key === 'lowestPax' ? 'Lowest Pax' : 'Fastest Flight Time'}
              </span>
            </label>
          ))}
        </div>

        {/* Time of day Section */}
        <div className="mb-4 pt-4 border-t border-[#eee]">
          <h4 className="font-bold text-[#000] mb-3 text-sm">Time of day</h4>
          <div className="space-y-2">
            {['morning', 'afternoon', 'evening'].map(time => (
              <label key={time} className="flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={filters[time]}
                  onChange={(e) => onFilterChange(time, e.target.checked)}
                  className="mr-2 w-4 h-4 accent-[#e87722]"
                />
                <span className="text-sm text-[#333] capitalize">{time}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Sort By Section */}
        <div className="mb-4 pt-4 border-t border-[#eee]">
          <h4 className="font-bold text-[#000] mb-3 text-sm">Sort By</h4>
          <select
            value={filters.sortBy || 'default'}
            onChange={(e) => onFilterChange('sortBy', e.target.value)}
            className="w-full border border-[#ddd] rounded px-3 py-2 text-sm text-[#333] focus:outline-none focus:border-[#e87722]"
          >
            {SORT_OPTIONS.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>

        {/* Reset Button */}
        <button
          onClick={onReset}
          className="w-full bg-[#e87722] hover:bg-[#d06a1a] text-white text-sm font-medium py-2 px-4 rounded flex items-center justify-center gap-2 transition-colors"
        >
          <FiRefreshCw size={16} /> Reset All Filters
        </button>
      </div>
    </div>
  );
};

export default FlightFilters;
